import { useEffect, useState } from "react";
import { CheckboxMultipleSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";
import { BadgeCheck, CircleCheck, CirclePlus, ReceiptRussianRuble, Trash } from "lucide-react";

type AppCustomPropertySettingsCheckboxMultipleProps = {
    settings: CheckboxMultipleSettings
    onChange: (settings: CheckboxMultipleSettings, disabled: boolean) => void;
}

export const AppCustomPropertySettingsCheckboxMultiple = ({settings, onChange} : AppCustomPropertySettingsCheckboxMultipleProps) => {

    const [choices, setChoices] = useState<string[]>(settings.choices || []);
    const [defaultChoices, setDefaultChoices] = useState<string[]>(settings.default || []);

    const [flashEmpty, setFlashEmpty] = useState(false);
    const [error, setError] = useState<string>("");
    const [hasErrorState, setHasErrorState] = useState<boolean>(false);


    useEffect(() => {
        const newSettings = {...settings, default: defaultChoices, choices};
        onChange(newSettings, hasErrorState || choices.length === 0);
    }, [choices, defaultChoices]);

    useEffect(() => {
        if (flashEmpty) {
            setTimeout(() => {
                setFlashEmpty(false);
            }, 1000);
        }
    }, [flashEmpty]);

    const caseInsensitiveDupeChoices = (choices: string[]) : boolean => {
        const counts: Record<string, number> = {};
        for (const choice of choices) {
            if (typeof choice !== "string") continue;
            const key = choice.trim().toLowerCase();
            counts[key] = (counts[key] || 0) + 1;
        }
        return Object.values(counts).some((count) => count > 1);
    }

    const anyBlanks = (choices: string[]) : boolean => {
        return choices.some((choice) => choice.trim() === "");
    }

    const dupes = caseInsensitiveDupeChoices(choices);
    console.log("[AppCustomPropertySettingsCheckboxMultiple] hasErrorState: ", hasErrorState);

    return (
        <div className="app-custom-property-settings-container">

            <div className="app-custom-property-group">
                <div className="app-custom-property-label">
                    Alphabetize
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.alphabetize}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                alphabetize: checked
                            }, hasErrorState || choices.length === 0);
                        }}
                    />
                </div>
            </div>

            {/* <div className="app-custom-property-group">
                <div className="app-custom-property-label">
                    Allow None
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.allowNone}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                allowNone: checked
                            }, hasErrorState || choices.length === 0);
                        }}
                    />
                </div>
            </div> */}

            Checkbox Choices: 
            <br />
            <span
                style={{cursor: "pointer", color: "blue"}}
                onClick={() => {
                    // if (choices.includes("")) {
                    //     setFlashEmpty(true);
                    //     return;
                    // } 

                    setFlashEmpty(false);
                    setChoices([...choices, ""]);
                    setHasErrorState(true);
                }}
            >
                Add Choice
            </span>

            <div className="app-custom-property-choices">
                {choices.map((choice, index) => {
                    return (
                        <div 
                            key={index}
                            className="app-custom-property-choice"
                        >
                            <input 
                                type="text"
                                placeholder="Enter another choice"
                                autoFocus={index === choices.length - 1}
                                value={choice}
                                onKeyDown={(e) => {
                                    if (index === choices.length -1 && e.key === "Enter") {                
                                        setChoices([...choices, ""]);
                                    }

                                }}
                                onChange={(e) => {
                                    if (index === choices.length -1 && e.target.value.trim() === "") {
                                        setHasErrorState(true);
                                        setError("");
                                    } else if (dupes) {
                                        setHasErrorState(true);
                                        setError("Duplicate choices not allowed");
                                    } else {
                                        setHasErrorState(false);
                                        setError("");
                                    }
                                         
                                    const newChoices = [...choices];
                                    newChoices[index] = e.target.value;

                                    if (anyBlanks(newChoices)) {
                                        setHasErrorState(true);
                                        // setError("Blank choices not allowed");
                                    } else if (caseInsensitiveDupeChoices(newChoices)) {
                                        setHasErrorState(true);
                                        setError("Duplicate choices not allowed");
                                    } else {
                                        setHasErrorState(false);
                                        setError("");
                                    }
                            
                                    setChoices(newChoices);
                                }}
                                style={flashEmpty && choice === "" ? {borderColor: "red"} : {}}
                            />
                            
                            <div 
                                className="app-custom-property-choice-default"
                                style={(defaultChoices.length > 0 && defaultChoices.includes(choice)) ? {display: "flex"} : {}}
                            >
                                {choice &&
                                    <BadgeCheck 
                                        size={16}
                                        color={defaultChoices.includes(choice) ? "green" : "black"}
                                        onClick={() => {
                                            setDefaultChoices(defaultChoices.includes(choice) ? 
                                                defaultChoices.filter((c) => c !== choice) : [...defaultChoices, choice]);
                                        }}
                                    />
                                }
                            </div>

                            <div className="app-custom-property-choice-delete">
                                <Trash 
                                    size={16}
                                    onClick={() => {
                                        const newChoices = choices.filter((_, i) => i !== index);

                                        if (anyBlanks(newChoices)) {
                                            setHasErrorState(true);
                                            // setError("Blank choices not allowed");
                                        } else if (caseInsensitiveDupeChoices(newChoices)) {
                                            setHasErrorState(true);
                                            setError("Duplicate choices not allowed");
                                        } else {
                                            setHasErrorState(false);
                                            setError("");
                                        }

                                        setChoices(newChoices);
                                    }}
                                />
                            </div>
                           
                            <div className="app-custom-property-choice-default">
                                <CircleCheck 
                                    size={16}
                                    onClick={() => {
                                        setDefaultChoices(defaultChoices.includes(choice) ? 
                                            defaultChoices.filter((c) => c !== choice) : [...defaultChoices, choice]);
                                    }}
                                    color={(choice && defaultChoices.includes(choice)) ? "green" : (choice ? "black" : "gray")}
                                />
                            </div>
                           
                        </div>
                    )}
                )}
            </div>

            {error && (
                <div className="app-custom-property-dupe-choices" style={{color: "red"}}>
                   {error}
                </div>
            )}
          
        </div>
    )
}